// extracted by mini-css-extract-plugin
module.exports = {"line-item-prescription":"lineItemPrescriptions_line-item-prescription__5E4Ug","name":"lineItemPrescriptions_name__2hDfr"};